export default __webpack_public_path__ + "img/accha/accha4_1500.jpg";